import { Component, OnDestroy, ViewChild } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { filter, tap } from 'rxjs/operators'
import { MatTabNav } from '@angular/material/tabs'
import { NavigationEnd, Router } from '@angular/router'
import { Subscriptions } from '../../utils/subscriptions'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { PendingState, selectCustomerPendingState } from '../account.root.state'

@Component({
  selector: 'cover-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnDestroy {
  private readonly subscriptions: Subscriptions = new Subscriptions(true)
  readonly pendingState = PendingState
  pending$: Observable<PendingState>

  links: TabLink[] = [
    { routerLink: '/navigation/account/address', tabLabel: '' },
    { routerLink: '/navigation/account/payment-methods', tabLabel: '' },
  ]
  activeLink?: TabLink
  // MatTabNav reference
  @ViewChild(MatTabNav, { static: true }) nav?: MatTabNav

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  constructor(
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly store: Store,
  ) {
    this.pending$ = store.select(selectCustomerPendingState)
    this.subscriptions.plusOne = this.router.events
      .pipe(
        filter(() => this.subscriptions.active),
        filter(event => event instanceof NavigationEnd),
        tap(event => {
          const link = this.links.find(
            l =>
              l.routerLink.toLowerCase().trim() ===
              (event as NavigationEnd).urlAfterRedirects.toLocaleLowerCase().trim(),
          )
          if (link != null) this.activeLink = link
        }),
      )
      .subscribe()

    this.subscriptions.plusOne = translate
      .get(['ACCOUNT.NAVBAR.MY_ADDRESSES', 'ACCOUNT.NAVBAR.PAYMENT_METHODS'])
      .pipe(
        filter(() => this.subscriptions.active),
        tap(res => {
          this.links[0].tabLabel = res['ACCOUNT.NAVBAR.MY_ADDRESSES']
          this.links[1].tabLabel = res['ACCOUNT.NAVBAR.PAYMENT_METHODS']
        }),
      )
      .subscribe()
  }

  switchToLeftTab($event: any): void {
    if (this.activeLink !== this.links[0] && $event.pointerType == 'touch') {
      this.router.navigateByUrl(this.links[this.links?.findIndex(it => it === this.activeLink) - 1].routerLink)
    }
  }

  switchToRightTab($event: any): void {
    if (this.activeLink !== this.links[this.links.length - 1] && $event.pointerType == 'touch') {
      this.router.navigateByUrl(this.links[this.links?.findIndex(it => it === this.activeLink) + 1].routerLink)
    }
  }
}

interface TabLink {
  routerLink: string
  tabLabel: string
}
